import { Copy } from "lucide-react";
import toast from "react-hot-toast";

interface CopyButtonProps {
  text: string;
  label: string;
  size?: number;
}

const CopyButton = ({ text, label, size = 14 }: CopyButtonProps) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    toast.success(`${label} copied!`);
  };

  return (
    <button
      onClick={handleCopy}
      className="text-gray-400 hover:text-[#2462b2] transition"
    >
      <Copy size={size} />
    </button>
  );
};

export default CopyButton;
